function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUparrowRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10422",
    transform: "translate(-564 -212)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5592",
    width: 48,
    height: 48,
    rx: 8,
    transform: "translate(564 212)",
    style: {
      fill: "#c33532",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "arrow-up (2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 73",
    transform: "translate(588 228)",
    style: {
      fill: "none",
      stroke: "#c33532",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M0 16V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41038",
    d: "m5 13 8-8 8 8",
    style: {
      fill: "none",
      stroke: "#c33532",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    transform: "translate(575 223)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrowRed);
export default __webpack_public_path__ + "static/media/uparrow_red.f2248222bfb8e6630d69fafec9870267.svg";
export { ForwardRef as ReactComponent };